import React from 'react';
import {
  StyledContainer,
  StyledErrorMessageDetails,
  StyledErrorMessageTitle,
} from './styles';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { appConfigSelector } from 'reducers/app.reducer';

export const SsoFailure = () => {
  const { t } = useTranslation();
  const { programName, ssoEmail } = useSelector(appConfigSelector);
  return (
    <StyledContainer>
      <StyledErrorMessageTitle>
        {t('auth.ssoFailure.errorMessageTitle')}
      </StyledErrorMessageTitle>
      <StyledErrorMessageDetails>
        {t('auth.ssoFailure.errorMessageDetails', { programName, ssoEmail })}
      </StyledErrorMessageDetails>
    </StyledContainer>
  );
};
